import React, { FC, ReactNode } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

interface ReCaptchaProviderProps {
  children: ReactNode;
}

const ReCaptchaProvider: FC<ReCaptchaProviderProps> = ({ children }) => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

  if (!siteKey) {
    if (!siteKey) {
      console.error("ReCaptcha site key is not configured");
    }
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      useEnterprise={true}
      scriptProps={{
        async: true,
        defer: true,
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default ReCaptchaProvider;
